import React from 'react';
import { partnersData } from '../../../data/partnersData';
import PartnerCard from './PartnerCardProps';

const PartnersList: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-6">
      {partnersData.map((partner) => (
        <PartnerCard
          key={partner.id}
          imageUrl={partner.imageUrl}
          logoUrl={partner.logoUrl}
          name={partner.name}
          description={partner.description}
          verified={partner.verified}
          category={partner.category}
        />
      ))}
    </div>
  );
};

export default PartnersList; 